import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "wallet",
  "use": "wallet-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"wallet\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6 2a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4v-8a4 4 0 0 0-4-4 4 4 0 0 0-4-4zm10 4H4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2M4 18V8h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2\" clip-rule=\"evenodd\" /><rect width=\"2\" height=\"4\" x=\"15\" y=\"12\" fill=\"currentColor\" rx=\"1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol